import FeatureGates from '@atlaskit/feature-gate-js-client';
import { SURFACE_ANALYTICS_PRODUCT_MAP } from '@atlassian/surface-analytics';
import type { Context } from '@atlassian/surface-sdk/types';

export const JSW_COPY = 'Track your issues and projects';
export const JSM_COPY = 'Automatically turn tickets into issues';
export const JPD_COPY = 'Build the right features, the right way';
export const ATLAS_COPY = 'Visualize, browse, and connect teams';
export const OPSGENIE_COPY = 'Stay aware and in control of incidents';
export const CONFLUENCE_COPY = 'Create one place for all your docs';

export const NUMBER_OF_RECOMMENDED_APPS = 2;

export const TBLZ_SWITCHER_ROLE_BASED_EXPERIMENT_NAME =
	'switcher_personalized_and_engaging_experience';

export const getExperimentCohort = (context: Context) => {
	const { product } = context;

	const isConfluence = product === 'confluence';
	const isJira = product === 'jira';

	if (!isConfluence && !isJira) {
		return 'not-enrolled';
	}

	const cohort = FeatureGates.getExperimentValue(
		TBLZ_SWITCHER_ROLE_BASED_EXPERIMENT_NAME,
		'cohort',
		'not-enrolled',
	);

	return cohort;
};

export const getRecommendationDescription = (
	description: string,
	productId: string,
	tblzSwitcherRoleBasedExperimentCohort?: string,
) => {
	if (tblzSwitcherRoleBasedExperimentCohort !== 'experiment') {
		return description;
	}

	switch (productId) {
		case SURFACE_ANALYTICS_PRODUCT_MAP.products['jira-servicedesk.ondemand']:
			return JSM_COPY;
		case SURFACE_ANALYTICS_PRODUCT_MAP.products['confluence.ondemand']:
			return CONFLUENCE_COPY;
		case SURFACE_ANALYTICS_PRODUCT_MAP.products['jira-software.ondemand']:
			return JSW_COPY;
		case SURFACE_ANALYTICS_PRODUCT_MAP.products['jira-product-discovery']:
			return JPD_COPY;
		case SURFACE_ANALYTICS_PRODUCT_MAP.products.townsquare:
			return ATLAS_COPY;
		case SURFACE_ANALYTICS_PRODUCT_MAP.products.opsgenie:
			return OPSGENIE_COPY;

		default:
			return description;
	}
};
